import React from 'react'
import ShareBillPayVirtualCardPopup from 'src/app/ShareBillPayVirtualCardPopup/ShareBillPayVirtualCardPopup'
import { SidenavContentType } from 'src/navigation/appLocations'
import { AppRoute } from 'src/navigation/appRoutes'
import { shareBillPayVirtualCardRouteProps } from 'src/navigation/routeProps'

import { AppLocation } from '../appLocations'

const ShareBillPayVirtualCardAppRoute: AppRoute = {
  id: AppLocation.ShareBillPayVirtualCard,
  routeProps: shareBillPayVirtualCardRouteProps,
  component: <ShareBillPayVirtualCardPopup />,
  subRoutes: [],
  meta: { contentType: SidenavContentType.Main },
}

export default ShareBillPayVirtualCardAppRoute
